<template>
    <a-card>
        <a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">
            <a-form-item label="需求名称" name="needName">
                <a-input v-model:value="searchForm.needName" placeholder="请输入需求名称"/>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="onSearch">查询</a-button>
                <a-button @click="onReset">重置</a-button>
            </a-form-item>
        </a-form>
        <div class="table-toolbar">

            <a-popconfirm title="确认要删除吗?" @confirm="onDeleteBatch(deleteUrl)" v-if="selectedRowKeys.length">
                <a-button danger>批量删除</a-button>
            </a-popconfirm>
        </div>
        <a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
            <template #message>
                已选择 {{ selectedRowKeys.length }} 项
                <a @click="onClearSelected" class="ml-20 float-right">清空</a>
            </template>
        </a-alert>
        <a-table
            :columns="columns"
            :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            :pagination="pagination"
            :data-source="dataSource"
            :loading="loading"
            @change="onTableChange">
            <!-- <template #index="{index}">{{ index + 1 }}</template> -->
            <template #needType="{text}">
                <dict-render :dict-obj="dictObjs['demand_type']" :text="text"></dict-render>
            </template>
            <!--            <template #dockingStatus="{text}">-->
            <!--                <a-tag><dict-render :dict-obj="dictObjs['condition']" :text="text" :style="dictObjs['condition']?.cssClass"></dict-render></a-tag>-->
            <!--            </template>-->
            <template #serviceStatus="{text}">
                <a-tag>
                    <dict-render :dict-obj="dictObjs['serviceStatus']" :text="text"
                                 :style="dictObjs['serviceStatus']?.cssClass"></dict-render>
                </a-tag>
            </template>
            <template #isOpen="{text}">
                <a-tag>
                    <dict-render :dict-obj="dictObjs['isPublic']" :text="text"
                                 :style="dictObjs['isPublic']?.cssClass"></dict-render>
                </a-tag>
            </template>
            <template #needName="{record}">
                <a @click="onDetail(record)">{{record.needName}}</a>
            </template>
            <template #action="{record}">
                <div class="table-row-operations">
                    <!--                    <a @click="onStateus(record)">服务状态修改</a>-->


                    <a @click="onSellerCancel(record)">取消</a>

<!--                    <a @click="onSellerCancel(record)">取消</a>-->
<!--                    <a @click="onAccomplish(record)">提交对接</a>-->
<!--                    <a @click="onVerify(record)">申请平台介入</a>-->
<!--                    <a @click="onDetail(record)">详情</a>-->
                </div>
            </template>
        </a-table>
    </a-card>
    <AddOrEditModal ref="modal" :form-primary-key-field="listKeyField" @finish="onFormEdited"/>
    <Detail ref="detailmodal" :form-primary-key-field="listKeyField" @finish="onFormEdited" @onCloseModel="onCloseModel"/>
<!--    <AbutmentListModal ref="abutmentlistmodal" :jointId="jointId" @onCloseModel="onCloseModel" />-->
</template>

<script>
    import AddOrEditModal from "./components/AddOrEditModal";
    import {dictMixin, tableListMixin} from "@/mixins";
    import {demandApi} from "@/api/innovationService";
    import DictRender from "@/components/other/DictRender";
    import Detail from "./components/DetailModal"
    // import AbutmentListModal from "./components/AbutmentListModal"

    const columns = [
        // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
        {title: "需求名称", dataIndex: "needName", key: "needName", slots: {customRender: "needName"}},

        {title: "需求类型", dataIndex: "needType", key: "needType", slots: {customRender: "needType"}},
        {title: "发布者名称", dataIndex: "needUserName", key: "needUserName"},
        // {title: "对接状态", dataIndex: "dockingStatus", key: "dockingStatus",slots: {customRender: "dockingStatus"}},
        {title: "对接状态", dataIndex: "serviceStatus", key: "serviceStatus", slots: {customRender: "serviceStatus"}},
        // {title: "发布状态", dataIndex: "isOpen", key: "isOpen", slots: {customRender: "isOpen"}},
        {title: "操作", dataIndex: "action", key: "action", slots: {customRender: "action"}},
    ];
    export default {
        name: "index",
        mixins: [tableListMixin, dictMixin],
        components: {
            DictRender,Detail,AddOrEditModal
        },
        data() {
            return {
                dictNames: 'isPublic,serviceStatus,condition,demand_type',
                columns,
                queryParamFixed: {systemType: "knowledge"},
                listUrl: demandApi.needList,
                listKeyField: "id",
                deleteUrl: demandApi.remove,
                jointId:null,
            }
        },
        methods: {
            onAdd() {
                this.onShowModal('modal');
            },
            onVerify(record){
                this.onShowModal('modal',{id:record.id,urlType:'1'});
                // this.postAction({
                //     url: demandApi.verify,
                //     params: {id: record.id}
                // }).then(res => {
                //     console.log("res", res)
                // })
            },
            onSellerCancel(record) {
                this.postAction({
                    url: demandApi.purchaserCancel,
                    params: {id: record.id}
                }).then(res => {
                    console.log("res", res)
                })
            },
            onAccomplish(record) {
                this.onShowModal('modal',{id:record.id,urlType:'2'});
                // this.postAction({
                //     url: demandApi.accomplish,
                //     params: {id: record.id}
                // }).then(res => {
                //     console.log("res", res)
                // })
            },
            onDetail(record) {
                this.getAction({
                    url: demandApi.detail,
                    params: {
                        id: record.id,
                    }
                }).then(res => {
                    console.log(res, 'res')
                    this.onShowModal("detailmodal", res)
                })
            },
        }
    }
</script>

<style scoped>

</style>
